export enum BILLING_SUBSCRIPTION_STATUS {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  INCOMPLETE_PAYMENT = 'incomplete_payment',
  TRIALING = 'trialing',
  ON_GRACE_PERIOD = 'on_grace_period',
}
